import { Component, OnInit } from '@angular/core';
// import {PerfectScrollbarConfigInterface} from "ngx-perfect-scrollbar";

@Component({
  selector: 'app-my-web-desk-content',
  templateUrl: './my-web-desk-content.component.html',
  styleUrls: ['./my-web-desk-content.component.css']
})
export class MyWebDeskContentComponent implements OnInit {

  constructor() { }
  ngOnInit(): void {}

}
